var exports = {
  "Lw": "UploadDropModal.module__overlay___QjdKVT",
  "r3": "UploadDropModal.module__dialog___QjdKVT",
  "ew": "UploadDropModal.module__dialogIconCircle___QjdKVT",
  "aY": "UploadDropModal.module__dialogIcon___QjdKVT",
  "tp": "UploadDropModal.module__dialogTextBlock___QjdKVT",
  "nl": "UploadDropModal.module__dialogTitle___QjdKVT",
  "HP": "UploadDropModal.module__dialogDescription___QjdKVT",
  "ly": "UploadDropModal.module__statusBanner___QjdKVT",
  "zm": "UploadDropModal.module__statusBannerActive___QjdKVT",
  "Sl": "UploadDropModal.module__statusBannerDefault___QjdKVT",
  "UX": "UploadDropModal.module__statusIndicator___QjdKVT",
  "Ie": "UploadDropModal.module__statusIndicatorActive___QjdKVT",
  "I8": "UploadDropModal.module__statusIcon___QjdKVT",
};

module.exports = exports;
